import React, { ReactNode } from "react";
import { SubHeader } from "src/components";
interface OrderTypeExceptionLayoutProps {
    children: ReactNode;
}

const OrderTypeExceptionLayout: React.FC<OrderTypeExceptionLayoutProps> = ({ children }) => {

    return (
        <div className="w-full">
            <SubHeader />
            {children}
        </div>
    );
};

export default OrderTypeExceptionLayout;
